module.exports = __webpack_public_path__ + "static/img/sauce_2.a0b76ca0.webp";